import {useTheme, Button, Alert} from "@mui/material"
import Grid from "@mui/material/Grid2"
import {useDispatch} from "react-redux"
import {useHistory} from "react-router-dom"

const alertStyles = theme => ({
  margin: theme.spacing(1)
})


const planAlertStyles = (theme, severity) => ({
  margin: theme.spacing(1),
    color: severity === "error" ? "#d40000" : "#0055d4",
    backgroundColor: "transparent",
  "& .MuiAlert-icon": {
    color: severity === "error" ? "#d40000" : "#0055d4"
  }
});

const AlertItem = props => {
  const {error, isPlanAlert} = props
  const theme = useTheme()
  const dispatch = useDispatch()
  const history = useHistory()

  const hasButton = error.resolveAction || error.resolveLocation
  const buttonText = error.resolveAction
    ? error.resolveActionText
    : error.resolveLocation
      ? error.resolveLocationText
      : ""
  const buttonAction = error.resolveAction
    ? () => dispatch(error.resolveAction())
    : error.resolveLocation
      ? () => history.push(error.resolveLocation)
      : null

  return (
    <Alert
      sx={{
        ...(isPlanAlert ? planAlertStyles(theme, error.severity) : alertStyles(theme)),
        whiteSpace: "pre-line"
      }}
      severity={error.severity ? error.severity : "error"}
      action={
        hasButton && (
          <Button color="inherit" size="small" onClick={buttonAction}>
            {" "}
            {buttonText}{" "}
          </Button>
        )
      }
      backgroundcolor="transparent"
    >
      {error.message}
    </Alert>
  )
}

export const Alerts = props => {
  const {errors, isPlanAlert} = props
  return (
    <Grid size={12} key={"upper_text"}>
      {errors.map((e, i) => (
        <AlertItem key={"error_" + i} error={e} isPlanAlert={isPlanAlert}/>
      ))}
    </Grid>
  )
}
